import type { CommonData } from '@/components/blockEditor/blockEditor.types';
import { CURRENT_SCHEMA_VERSION } from '@/components/blockEditor/blockEditor.types';

export function getDefaultCltOverviewPageTwoData(): CommonData {
  return {
    version: CURRENT_SCHEMA_VERSION,
    blocks: [
      {
        id: 'clt-overview-page-two-list',
        type: 'ListItemsSection',
        props: {},
        children: {
          default: [
            {
              id: 'clt-overview-page-two-heading',
              type: 'EducationalSlideHeading',
              props: {
                title: 'Is a CLT right for me?',
                variant: 'h3',
              },
            },
            {
              id: 'clt-overview-page-two-estate-size',
              type: 'PresentationListItem',
              props: {
                title: 'Estate size',
                description:
                  'If your estate exceeds or is close to the federal estate tax exemption, a CLT can provide significant tax benefits.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'clt-overview-page-two-philanthropy',
              type: 'PresentationListItem',
              props: {
                title: 'Philanthropic intent',
                description:
                  'If you are committed to leaving a lasting charitable legacy, a CLT can be an efficient way to support the causes that you care about.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'clt-overview-page-two-tax-payments',
              type: 'PresentationListItem',
              props: {
                title: 'Ongoing tax payments',
                description:
                  'If you do not want to be responsible for making ongoing tax payments on trust income, consider avoiding a Grantor CLT.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
            {
              id: 'clt-overview-page-two-guidance',
              type: 'PresentationListItem',
              props: {
                title: 'Professional guidance',
                description:
                  'Consulting with estate planning professionals, including attorneys and financial advisors, is essential to evaluate whether a CLT aligns with your overall financial strategy.',
                iconType: 'check',
                iconColor: 'PRIMARY',
              },
            },
          ],
        },
      },
    ],
  };
}
